module.exports = __webpack_public_path__ + "static/media/country.40c9cdc5.svg";